/** A provider error's `status` and `type` (UD-32): they cross the worker boundary so the page can word the cause. */
export function providerFields(e: unknown): { status?: number; type?: string } {
	const o = (e ?? {}) as { status?: unknown; type?: unknown };
	return {
		...(typeof o.status === 'number' ? { status: o.status } : {}),
		...(typeof o.type === 'string' ? { type: o.type } : {}),
	};
}
